import 'globalCommon/style/common.css';
import 'globalCommon/style/iconfont.css';
import 'globalCommon/style/reset.css';
import 'pcCommon/style/common.css';

import { gdprCom, ipPrompt } from '@umu/umu-prompt';
import 'babel-polyfill';
import { loadResource, registerBesChannels } from 'globalCommon/gdprResource';
import getUserInfo, { IUserInfo } from 'globalCommon/services/getUserInfo';
import isInitRegisterBtn from '../../../common/utils/isInitRegisterBtn';
import registerSentry from '../../../common/utils/sentry';
import { initHeader, initFooter } from 'globalCommon/utils/headerFooterRender';

if (document.body) {
    document.body.classList.add('locale-' + LOCALE.toLowerCase());
    document.body.classList.add('system-' + SYSTEM.toLowerCase());
}

declare global {
    interface Window {
        HomeHeader: any;
        HomeFooter: any;
    }
}

const initGDPR = (userId?: string) => {
    gdprCom({
        userId,
        platform: 'web',
        lang: LOCALE.toLowerCase(),
        onAgree: () => {
            loadResource();
        },
    });
};

function showPrompt(userId?: string) {
    const commonConfig = {
        userId,
        stayFunc: initGDPR,
    };
    if (SYSTEM.toLowerCase() === 'en') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'CN',
                    from: 'UMU.COM',
                    to: 'umu.cn',
                    lang: 'cn',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'JP',
                    from: 'UMU.COM',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
            ],
            commonConfig,
        );
    } else if (SYSTEM.toLowerCase() === 'em') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'CN',
                    from: 'UMU.IO',
                    to: 'umu.cn',
                    lang: 'cn',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'JP',
                    from: 'UMU.IO',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
            ],
            commonConfig,
        );
    } else {
        initGDPR(userId);
    }
}

export default (option?: { hideHeard?: boolean; cb?(userInfo: IUserInfo): void; renderAfter?: () => void }) => {
    const userInfo = getUserInfo();

    option?.renderAfter?.();
    if (!option?.hideHeard) {
        if (userInfo?.umu_id == 0 && !userInfo?.user_name) {
            initHeader({ isMobile: false });
            isInitRegisterBtn();
        } else {
            initHeader({ isMobile: false, userInfo });
            isInitRegisterBtn(userInfo);
        }
    }
    initFooter({ isMobile: false });
    option?.cb?.(userInfo);

    if (SYSTEM.toLowerCase() !== 'cn') {
        showPrompt(userInfo?.umu_id ? String(userInfo.umu_id) : undefined);
    } else {
        registerBesChannels();
    }

    registerSentry();
};

window.VERSION = VERSION;
window.branch = BRANCH;
